import type {FileApiModel} from '../../api/media/file';
import type {ThemeColor} from '../../styles/theme';
import type {IFileSrc} from '../../utils/entity/file';

import {allOf} from '../../utils/conditionalUtils';
import {
  getFileExtension,
  getFileName,
  getFileSrc,
} from '../../utils/entity/file';
import {getFileIcon} from '../../utils/entity/file/getFileIcon';

export class IFileModel {
  file: FileApiModel;
  private src: IFileSrc;

  constructor(file: FileApiModel) {
    this.file = file;

    this.src = getFileSrc(file);
  }

  get accentColor(): ThemeColor | undefined {
    if (this.isVideo) {
      return 'global2';
    }

    if (this.isDocument) {
      return 'global1';
    }
  }

  get ext() {
    return getFileExtension(this.name);
  }

  get icon() {
    return getFileIcon(this.file);
  }

  get isDocument() {
    return allOf([this.isVideo, this.isUrl, this.isImage], false);
  }

  get isImage() {
    return this.file.categories.includes('image');
  }

  get isUrl() {
    return this.file.type === 'url';
  }

  get isVideo() {
    return this.file.categories.includes('video');
  }

  get name() {
    return getFileName(this.file);
  }

  get nameWoExt() {
    return this.name.replace(`.${this.ext}`, '');
  }

  get preview() {
    if (this.file.categories.includes('website')) {
      return getFileSrc(this.file, 'image').url;
    } else if (this.file.categories.includes('image')) {
      return this.src.url;
    } else {
      return null;
    }
  }

  get size() {
    return this.src.size;
  }

  get url() {
    return this.src.urlrepr;
  }
}
